<template>
	<div class="wrap_connected">
		<button
			v-for="(item, idx) in props.items"
			:key="idx"
			:class="item === selectedTab && 'selected'"
			@click="onClickTab(item)"
		>
			{{ item }}
		</button>
	</div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
	items: string[];
	selectedItem?: string;
	sort?: string;
}>();
const emit = defineEmits(['update:detailTab']);
const selectedTab = ref(props.selectedItem ?? props.items[0]);

const onClickTab = (item: string) => {
	selectedTab.value = item;
	if (props.sort) {
		emit('update:detailTab', selectedTab.value, props.sort);
	} else {
		emit('update:detailTab', selectedTab.value);
	}
};

watch(
	() => props.selectedItem,
	() => {
		if (props.selectedItem) selectedTab.value = props.selectedItem;
	}
);
</script>

<style scoped lang="scss">
.wrap_connected {
	padding: 0.4rem;
	width: max-content;
	display: flex;
	gap: 0.4rem;
	background-color: var(--color-bg-mid);
	border-radius: 6px;
}
button {
	display: flex;
	padding: 0.7rem 1.3rem;
	justify-content: center;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	border-radius: 6px;

	font-size: var(--font-s-mid);
	font-weight: var(--font-w-semi-bold);
	line-height: normal;
}
.selected {
	color: var(--color-bg-mid);
	background-color: #fff;
}
</style>
